import { Button, CloseIcon } from "@forge/common";
import React from "react";
import Title from "../../common/components/title-container/title"; // Adjust the path as needed
import { NormalText } from "../../common/components/title-container/LText"; // Adjust the path as needed
import { btnResponsive } from "../../common/utils/helper";
import ButtonComponent from "../../common/components/button/button";

interface HeaderComponentProps {
  title: string;
  onCancel: () => void;
}

export const HeaderComponent: React.FC<HeaderComponentProps> = ({
  title,
  onCancel,
}) => {
  return (
    <div className="flexContainer justifyContent-spaceBetween alignItems-center pt-2 mt-4">
      <NormalText
        title={title}
        className={`text-lg ${btnResponsive("text-lg")} font-bold`}
      />
      <CloseIcon
        onClick={onCancel}
        className="cursor-pointer text-[#E0E0E0] font-bold text-lg"
      />
    </div>
  );
};

export const FooterComponent = ({
  onCancel,
  onTrigger,
  btnText,
  btnText1,
  disabled,
}: {
  onCancel: () => void;
  onTrigger: () => void;
  btnText?: string;
  btnText1?: string;
  disabled?: boolean;
}) => {
  return (
    <div className={"flexContainer justifyContent-center gap-3 mt-5  mb-5"}>
      {btnText && (
        <ButtonComponent
          variant="secondary"
          size="regular"
          data-testid="cancel-button"
          onClick={onCancel}
          className={`text-base font-w-700 mr-4 ${btnResponsive()}`}
          title={btnText}
        />
      )}
      {btnText1 && (
        <ButtonComponent
          variant="primary"
          size="regular"
          data-testid="continue-button"
          className={`text-base font-w-700 ${btnResponsive()}`}
          onClick={onTrigger}
          disabled={disabled}
          title={btnText1}
        />
      )}
    </div>
  );
};

export const UploadFileManagement = ({
  title,
  description,
  btnText1,
  btnText,
  onCancel,
  onTrigger,
  disabled = false,
}: {
  title: string;
  description?: string;
  btnText1?: string;
  btnText?: string;
  onCancel: () => void;
  onTrigger: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className="flexContainer flexDirection-column w-[400px]">
      <HeaderComponent title={title} onCancel={onCancel} />
      <div className="mt-2 pt-5 pr-10">
        <NormalText
          title={description}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}
        />
      </div>
      <div className="flexContainer justify-end items-end mt-4 height-100">
        <FooterComponent
          btnText1={btnText1}
          btnText={btnText}
          onCancel={onCancel}
          onTrigger={onTrigger}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export const RetryCheckFileManagement = ({
  title,
  description,
  btnText1,
  btnText,
  onCancel,
  onTrigger,
  disabled = false,
}: {
  title: string;
  description?: string;
  btnText1?: string;
  btnText?: string;
  onCancel: () => void;
  onTrigger: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className="flexContainer flexDirection-column w-[400px]">
      <HeaderComponent title={title} onCancel={onCancel} />
      <div className="pt-2 pr-10">
        <NormalText
          title={description}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}
        />
      </div>
      {/* <div className="mt-2 pt-5 pr-10">
        <NormalText
          title={" Note:"}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}
        />
        <NormalText
          title={
            "On overwrite, the file may take up to 24 hours to reflect in DataShare."
          }
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}
        /> */}
      {/* <NormalText title={"(i) if it was already synced, will be available in DataShare but may not be viewable in Dashboard for up to 24 hours"} className={`text-xs ${btnResponsive("text-xs")} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}/> */}
      {/* <NormalText title={"(ii) if it was not synced, will not be available anymore in DataShare or Dashboard"} className={`text-xs ${btnResponsive("text-xs")} xl-high:!leading-[32px] !leading-[20px] font-medium text-[#E0E0E0]`}/> */}
      {/* </div> */}
      <div className="flexContainer justify-end items-end mt-4 height-100">
        <FooterComponent
          btnText1={btnText1}
          btnText={btnText}
          onCancel={onCancel}
          onTrigger={onTrigger}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
